import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import useApp from "../../../utils/useApp";
import { useLocation } from "react-router-dom";
import { currentUrl } from "../../../App";
import { fetchFields, fetchJobs, fetchPrograms } from "../../../services/httpClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShieldHalved, faThumbTack, faUsersLine } from "@fortawesome/free-solid-svg-icons";
import Programs from "./Programs";
import Jobs from "./Jobs";
import SaveChangesModal from "../../ui/SaveChangesModal";
import Fields from "./FIelds";

interface OrgHouseholdState {
  setOrgToSave: any;
  getData: boolean;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const OrgHousehold = ({ setOrgToSave, getData, setShowToast, setToastText, setToastBody }: OrgHouseholdState) => {
  const { auth, showMenu }: any = useApp();
  const location = useLocation();
  currentUrl.value = location.pathname;
  const [errMsg, setErrMsg] = useState("");
  const [showPrograms, setShowPrograms] = useState(true);
  const [showJobs, setShowJobs] = useState(false);
  const [showFields, setShowFields] = useState(false);
  const [programs, setPrograms] = useState<any[]>([]);
  const [jobs, setJobs] = useState<any[]>([]);
  const [fields, setFields] = useState<any[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (getData) {
      setIsLoading(true);
      getPrograms();
      getJobs();
      getFields();
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  }, [getData]);

  useEffect(() => {
    getPrograms();
    getJobs();
    getFields();
  }, [auth?.profile]);

  const getPrograms = () => {
    fetchPrograms()
      .then((res: any) => {
        const progs = res[0].data;
        setPrograms(progs);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const getJobs = () => {
    fetchJobs()
      .then((res: any) => {
        const jobs = res[0].data;
        const groupedByDepartment = Object.values(
          jobs.reduce(
            (acc: any, job: any) => {
              acc[job.department] = acc[job.department] || [];
              acc[job.department].push(job);
              return acc;
            },
            {} as Record<string, any[]>,
          ),
        );
        setJobs(groupedByDepartment);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const getFields = () => {
    fetchFields()
      .then((res: any) => {
        var fields = res[0].data;
        fields = fields.map((f: any) => ({ ...f, name: f.label }));

        setFields(fields);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const updateSelection = (type: string) => {
    switch (type) {
      case "program":
        setShowPrograms(true);
        setShowJobs(false);
        setShowFields(false);
        break;
      case "job":
        setShowPrograms(false);
        setShowJobs(true);
        setShowFields(false);
        break;
      case "field":
        setShowPrograms(false);
        setShowJobs(false);
        setShowFields(true);
        break;
      default:
        setShowPrograms(true);
        setShowJobs(false);
        setShowFields(false);
        break;
    }
  };

  return (
    <>
      {isLoading ? (
        <Container className={showMenu ? "lg div-main-menu" : "lg div-main"}>
          <Button size="sm" className="spinner-button spinner-button-main">
            <Spinner animation="border" style={{ color: "#F6893D" }} />
          </Button>
        </Container>
      ) : (
        <>
          <p className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">
            {errMsg}
          </p>
          <Row className="mb-4">
            <Col xs={3}>
              <h4 className="app-header-text">Household Config</h4>
            </Col>
            <Col xs={3} className="d-grid">
              <Button
                className={showPrograms ? "app-primary-color button button-toggle" : "app-primary-color-inverse button button-toggle"}
                onClick={() => updateSelection("program")}
              >
                <FontAwesomeIcon icon={faUsersLine} className={"me-2"} />
                {"Programs"}
              </Button>
            </Col>
            <Col xs={3} className="d-grid">
              <Button
                className={showJobs ? "app-primary-color button button-toggle" : "app-primary-color-inverse button button-toggle"}
                onClick={(e) => updateSelection("job")}
              >
                <FontAwesomeIcon icon={faThumbTack} className={"me-2"} />
                {"Jobs"}
              </Button>
            </Col>
            <Col xs={3} className="d-grid">
              <Button
                className={showFields ? "app-primary-color button button-toggle" : "app-primary-color-inverse button button-toggle"}
                onClick={(e) => updateSelection("field")}
              >
                <FontAwesomeIcon icon={faShieldHalved} className={"me-2"} />
                {"Custom Fields"}
              </Button>
            </Col>
          </Row>
          {showPrograms === true && (
            <Programs
              programs={programs}
              getPrograms={getPrograms}
              setOrgToSave={setOrgToSave}
              setErrMessage={setErrMsg}
              setShowToast={setShowToast}
              setToastText={setToastText}
              setToastBody={setToastBody}
            />
          )}
          {showJobs === true && (
            <Jobs
              jobs={jobs}
              getJobs={getJobs}
              setOrgToSave={setOrgToSave}
              setErrMessage={setErrMsg}
              setShowToast={setShowToast}
              setToastText={setToastText}
              setToastBody={setToastBody}
            />
          )}
          {showFields === true && (
            <Fields
              fields={fields}
              getFields={getFields}
              setOrgToSave={setOrgToSave}
              setErrMessage={setErrMsg}
              setShowToast={setShowToast}
              setToastText={setToastText}
              setToastBody={setToastBody}
            />
          )}
          <SaveChangesModal showModal={showModal} setShowModal={setShowModal} path="/settings" />
        </>
      )}
    </>
  );
};

export default OrgHousehold;
